/**
 * Wallet-ownership verification module for the YaaS Client Console.
 *
 * Three layers, colocated here:
 *   useWalletVerification → raw wallet I/O (signMessage / micro-transfer)
 *   useVerifyActionFlow   → step state machine driving the
 *                           AccountOwnershipVerificationPanel
 *   verifyFlowOutcome     → pure outcome → panel-state mapping (unit-tested)
 *
 * Consumers import the hooks (and their types) from this barrel; the
 * outcome mapper is an internal detail of the flow hook.
 */

export {
    MICRO_TRANSFER_PROOF_MAX_AGE_MS,
    useWalletVerification,
    type VerificationProof,
    type VerificationFailureReason,
    type VerifyOptions,
    type VerifyResult,
    type UseWalletVerificationResult
} from "./useWalletVerification";

export {
    useVerifyActionFlow,
    type UseVerifyActionFlowResult,
    type StartFlowArgs,
    type VerificationErrorKind,
    type VerificationMethod,
    type VerificationStep
} from "./useVerifyActionFlow";
